import { Icons } from '@/components/icons';
import { Checkbox } from '@/components/primitives/Checkbox';
import { Typography } from '@/components/primitives/Typography';
import type { LegDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import type { FC } from 'react';

interface LegPassengerSelectionCardProps {
  passenger: {
    firstName: string;
    lastName: string;
    carriages?: string;
    seats?: string;
    age?: number;
  };
  ptMode?: LegDTO['ptMode'];
  isSecondLevelItem?: boolean;
  className?: string;
  placeIcon?: 'seat' | 'compartment' | 'bed';
  isChecked: boolean;
  onToggle: (checked: boolean) => void;
}

export const LegPassengerSelectionCard: FC<LegPassengerSelectionCardProps> = ({
  passenger,
  isSecondLevelItem = false,
  placeIcon = 'seat',
  className,
  isChecked,
  onToggle,
  ptMode,
}) => {
  const IconComponent = Icons[placeIcon];

  return (
    <div
      className={cn(
        'cursor-pointer rounded-sm border border-neutral-light px-3 py-1.5 hover:border-primary-medium hover:bg-primary-pale',
        className,
        {
          'border-primary bg-primary-light': isChecked,
        }
      )}
      onClick={() => onToggle(!isChecked)}
      data-state={isChecked ? 'checked' : 'unchecked'}
    >
      <div className="flex items-center gap-3">
        <Checkbox checked={isChecked} onClick={() => onToggle(!isChecked)} />
        <div className="w-full">
          <div className="flex items-center justify-between gap-2">
            <Typography
              variant={isSecondLevelItem ? 'body2-bold' : 'body1-bold'}
            >
              {`${passenger.firstName} ${passenger.lastName}`}
            </Typography>
            <div className="flex items-center gap-1.5">
              {passenger.carriages && ptMode?.code !== 'BUS' && (
                <div className="flex items-center gap-1">
                  <Icons.carriage
                    height={12}
                    width={12}
                    className="text-neutral"
                  />
                  <Typography variant="body2-bold" className="text-neutral">
                    {passenger.carriages}
                  </Typography>
                </div>
              )}
              {passenger.seats && (
                <div className="flex items-center gap-1">
                  <IconComponent height={12} width={12} />
                  <Typography variant="body2-bold" className="text-neutral">
                    {passenger.seats}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
